import axios from './axios';

/**
 * Fetch all petty cash transactions with filters.
 */
export const getTransactions = async (params = {}) => {
  return await axios.get('/api/v1/petty-cash', { params });
};

/**
 * Fetch petty cash statistics (metrics).
 */
export const getStats = async () => {
  return await axios.get('/api/v1/petty-cash/stats');
};

/**
 * Fetch unique petty cash categories.
 */
export const getCategories = async () => {
  return await axios.get('/api/v1/petty-cash/categories');
};

/**
 * Create a new petty cash transaction.
 */
export const createTransaction = async (data) => {
  return await axios.post('/api/v1/petty-cash', data);
};

/**
 * Update an existing petty cash transaction.
 */
export const updateTransaction = async (id, data) => {
  return await axios.put(`/api/v1/petty-cash/${id}`, data);
};

/**
 * Delete a petty cash transaction.
 */
export const deleteTransaction = async (id) => {
  return await axios.delete(`/api/v1/petty-cash/${id}`);
};

/**
 * Update the opening balance for petty cash.
 */
export const updateOpeningBalance = async (opening_balance) => {
  return await axios.post('/api/v1/petty-cash/opening-balance', { opening_balance });
};
